import { getLobType } from "../../../../../actions/Utilities/LobType";
import { useQuery } from "react-query";

export default function useLobType() {
  //Fetching LobType Details
  const {data, isFetching} = useQuery("GetLobTypes", getLobType, {
    refetchOnWindowFocus: false,
  });

  return {data, isFetching};
}
